import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { catchError, map, of } from "rxjs";

import { UsersClient } from "../../apiClient/services";
import { NavigationService } from "../../services/navigation.service";

export const connectRoleAdminAuthGuard: CanActivateFn = () => {
  const usersClient = inject(UsersClient);
  const navigationService = inject(NavigationService);

  return usersClient.getSelf().pipe(
    map((userResponse) => {
      if (userResponse.connectRole === "Admin") {
        return true;
      }

      navigationService.navigateTo404();
      return false;
    }),
    catchError(() => {
      navigationService.navigateTo404();
      return of(false);
    }),
  );
};
